<template>
  <section class="gallery grid">
    <div class="gallery__inner container">
      <figure
        v-for="(size, index) in data.size"
        :key="index"
        :data-size="size"
        class="gallery__item"
        data-anim="figure"
        data-trans="next"
        v-if="size"
      >
        <div class="figure__inner apollo__link" @click="setCurrent(index)">
          <img
            :src="`/static/images/${data.id}/${padStart(index + 1, 2, '0')}_${data.id}.jpg`" alt="">
        </div>
      </figure>
    </div>
    <VueGallery
      :images="images"
      :index="current"
      :options="options"
      :style="{ transform: `translate3d(0, ${hades.ref.amount.y}px, 0)`, }"
    >
      <template v-slot:next>&nbsp;</template>
      <template v-slot:prev>&nbsp;</template>
      <template v-slot:close>&nbsp;</template>
    </VueGallery>
  </section>
</template>

<script>
import { padStart } from 'lodash';
import VueGallery from 'vue-gallery';
import hades from '@/scripts/hades';
import { TimelineLite, Expo } from 'gsap/TweenMax';

export default {
  name: 'Gallery',

  data() {
    return {
      padStart,
      current: null,
      hades,
      tweenUi: null,
      options: {
        stretchImages: true,
        transitionSpeed: 600,
        onclose: () => {
          this.setCurrent(null);
        },
        onclosed: () => {
          this.hades.ref.play();
          if (this.tweenUi) this.tweenUi.reverse();
          this.$eventHub.$emit('gallery-close');
        },
        onopened: () => {
          this.hades.ref.pause();
          if (this.tweenUi) this.tweenUi.play();
        },
      },
    };
  },

  components: {
    VueGallery,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    const aside = [document.querySelector('aside.right .aside__wrapper'), document.querySelector('aside.left .aside__wrapper')];
    this.tweenUi = new TimelineLite({ paused: true });
    this.tweenUi.to(aside, 0.5, {
      autoAlpha: 0,
      ease: Expo.easeOut,
    });
  },

  computed: {
    images() {
      const array = [];
      this.data.size.map((item, index) => array.push(`/static/images/${this.data.id}/${padStart(index + 1, 2, '0')}_${this.data.id}.jpg`));
      return array;
    },
  },

  methods: {
    setCurrent(index) {
      this.current = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  &__inner {
    display: flex;
    flex-flow: row wrap;
  }

  &__item {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    cursor: pointer;

    &:nth-child(odd) {
      justify-content: flex-start;
    }

    &:nth-child(even) {
      justify-content: flex-end;
    }

    margin-bottom: rem(30px);

    @include mq(ipadP) {
      margin: 0;
    }
  }

  .figure__inner {
    position: relative;
    overflow: hidden;
    flex: 0 0 100%;
  }

  [data-size="wide"] {
    flex: 0 0 100%;
    img {
      width: 100%;
      max-width: 100%;
    }
  }

  [data-size="medium"] {
    flex: 0 0 100%;
    img {
      flex: 0 0 100%;
      width: 100%;
      max-width: 100%;
    }

    @include mq(ipadP) {
      .figure__inner {
        margin: 0;
        flex: 0 0 50%;
        max-width: 50%;
        width: 50%;
      }
    }
  }
}
</style>

<style lang="scss">
.blueimp-gallery {
  height: 100vh;
  bottom: auto !important;
  pointer-events: none;
  background: #000000;

  @include mq($until: ipadP) {
    transform: none !important;
  }
}

.blueimp-gallery-display {
  pointer-events: auto;
}
.blueimp-gallery > .next,
.blueimp-gallery > .prev {
  position: absolute;
  top: 0;
  left: 0;
  width: 30vw;
  height: 100vh;
  margin-top: 0;
  text-shadow: none;
  background: transparent;
  box-sizing: border-box;
  border: none;
  border-radius: 0;
  opacity: 1;
  cursor: pointer;

  @include mq($until: ipadP) {
    display: none !important;
  }
}

.blueimp-gallery > .next {
  left: auto;
  right: 0;
}

.blueimp-gallery > .close {
  position: absolute;
  top: 0;
  left: 30vw;
  width: 40vw;
  padding: 0;
  height: 100vh;

  @include mq($until: ipadP) {
    right: 0;
    left: auto;
    width: auto;
    height: auto;
    padding: 30px;
    &::after {
      content: "×";
      font-size: 40px;
    }
  }
}

.blueimp-gallery > .title,
.blueimp-gallery > .description {
  display: none !important;
}
/* .slide-content {
  object-fit: cover;
} */
</style>
